import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['publishedRadio', 'unpublishedRadio'];

  initialize() {
    this.toggleStatus = this.toggleStatus.bind(this);
  }

  connect() {
    this.publishedRadioTarget.addEventListener('change', this.toggleStatus);
    this.unpublishedRadioTarget.addEventListener('change', this.toggleStatus);
  }

  disconnect() {
    this.publishedRadioTarget.removeEventListener('change', this.toggleStatus);
    this.unpublishedRadioTarget.removeEventListener('change', this.toggleStatus);
  }

  toggleStatus(event) {
    const experiencePublishFields = Array.from(document.querySelectorAll('.published-section'));
    const experienceUnpublishFields = Array.from(document.querySelectorAll('.unpublished-section'));

    if (event.target.value === 'published') {
      experiencePublishFields.forEach((field) => { field.style.display = 'block'; });
      experienceUnpublishFields.forEach((field) => { field.style.display = 'none'; });
    } else {
      experiencePublishFields.forEach((field) => { field.style.display = 'none'; });
      experienceUnpublishFields.forEach((field) => { field.style.display = 'block'; });
    }

    event.target.checked = 'checked';
  }
}
